import React, { useContext, useEffect, useRef } from "react";
import { FlickingError, ERROR_CODE } from "@egjs/react-flicking";

import Slider from "../slider/slider";
import Context from "../store/context";
import PhotoSlider from "./photoSlider/photoSlider";

const FooterSlider = () =>{
  
  const colorCtx = useContext(Context)
  const slideRef = useRef()
  const flickRef = useRef()

    useEffect(() =>{
        document.getElementById("footer__slider").append(slideRef.current)
    })
    
    useEffect(() => {
      async function sync(){
        try {
              await flickRef.current.moveTo(colorCtx.color);
        }
        catch (err) {
          if (err instanceof FlickingError) {
            if (err.code === ERROR_CODE.ANIMATION_ALREADY_PLAYING) {
            } else if (err.code === ERROR_CODE.ANIMATION_INTERRUPTED) {
            }
          }
        }
      }
      sync()    
    },[colorCtx.color])

    return(
        <div className="footerSlider" ref={slideRef}>
          <PhotoSlider cN="footerSlider__photoSlider" />  
          <Slider isRef={flickRef} cN="footerSlider__slider" color={colorCtx.color} setColor={(e) => colorCtx.setColor(e)} />
        </div>
    )
}

export default FooterSlider